<template>
  <div>
    <div v-if="quadVenue && quadVenue.race">
      <div
        class="race-title-bar"
        :style="raceTitleBar"
      >
        <div class="race-venue-flag">
          <img
            :src="flagImage(quadVenue.countryName)"
            alt=""
          >
        </div>

        <div class="race-venue-name">
          <div
            class="venue-name"
            :class="venueFlash"
          >
            {{ venueDisplayName(quadVenue.ve) }}
            <span
              v-if="hasNextVenue"
              class="showing-next"
            >Showing Next in {{ nextVenueIn }}s.</span>
          </div>
          <div
            class="race-name"
            :class="raceFlash"
          >
            {{ quadVenue.race.fn | race }} - {{ quadVenue.race.raceDateTime | satime }}
            <span
              v-if="hasNextRace"
              class="showing-next"
            >Showing Next in {{ nextRaceIn }}s.</span>
          </div>
        </div>

        <div class="race-titles">
          <div class="place-title">
            PLACE
          </div>

          <div class="prev-title">
            PREV
          </div>

          <div class="price-title">
            PRICE
          </div>

          <div class="race-places-paid">
            {{ quadVenue.race.placesPaid }} PLACES PAID
          </div>
        </div>
        <div class="clearfix" />
      </div>

      <div class="markets-container">
        <template v-for="market in quadVenue.race.markets">
          <Market
            v-if="market.include"
            :key="market.id"
            :places-paid="quadVenue.race.placesPaid"
            :place-percentage="quadVenue.race.placePercentage"
            :venue-id="quadVenue.venueId"
            :race-id="quadVenue.race.raceId"
            :market-id="market.marketId"
            :venue-index="venueIndex"
            :is-multi="true"
            :quadrant="quadrant"
          />
        </template>

        <Market
          :scroll-markets="quadVenue.race.scrollMarkets"
          :places-paid="quadVenue.race.placesPaid"
          :place-percentage="quadVenue.race.placePercentage"
          :venue-id="quadVenue.venueId"
          :race-id="quadVenue.race.raceId"
          :venue-index="venueIndex"
          :is-multi="true"
          :quadrant="quadrant"
        />
      </div>
    </div>

    <div
      v-if="!quadVenue"
      class="no-data"
    >
      No Venue or Race to Display
    </div>
  </div>
</template>

<script>
import Market from '@/components/Market';
import venuemixin from '../mixins/venuemixin';

export default {
  name: 'Multiscreensection',
  components: {
    Market
  },
  mixins: [venuemixin],
  props: ['quadrant'],
  data() {
    return {
      theTime: '',
      raceIndex: 0,
      venueIndex: 0,
      timeoutStarted: false,
      raceFlash: '',
      venueFlash: '',
      nextRaceIn: 0,
      nextVenueIn: 0,
      raceTimeout: null,
      venueTimeout: null,
      mainVenueCounter: 0,
      mainRaceCounter: 0
    };
  },
  computed: {
    screenData() {
      return this.$store.state.screenData;
    },
    raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    quadVenues() {
      let scope = this;

      return scope.screenData.filter(item => item.quadrant === scope.quadrant);
    },
    quadVenue() {
      let scope = this;
      let quadvenue = null;
      if (scope.quadVenues.length > 0) {
        quadvenue = scope.quadVenues[scope.venueIndex];
        if (quadvenue) {
          if (quadvenue.races.length > 0) {
            quadvenue.race = quadvenue.races[scope.raceIndex];
          }
        }
      }
      return quadvenue;
    },
    venueAndRacesReady() {
      return !!(this.quadVenues && this.quadVenues.length > 0);
    },
    hasNextRace() {
      return this.quadVenue.races.length > 1;
    },
    hasNextVenue() {
      return this.quadVenues.length > 1;

    }
  },
  watch: {
    venueAndRacesReady: function(newReady) {
      if (newReady) {
        let scope = this;

        scope.nextRaceIn = scope.$store.state.screenConfig.raceScrollInterval;
        scope.nextVenueIn = scope.$store.state.screenConfig.venueScrollInterval;

        setInterval(function() {

          scope.mainVenueCounter++;
          scope.mainRaceCounter++;

          if (scope.nextRaceIn > 0) {
            scope.nextRaceIn--;
          }
          if (scope.nextVenueIn > 0) {
            scope.nextVenueIn--;
          }

          if(scope.mainVenueCounter >= scope.$store.state.screenConfig.venueScrollInterval) {
            scope.scrollVenue();
            scope.mainVenueCounter = 0;

            if(scope.hasNextVenue) {
              scope.mainRaceCounter = 0;
              scope.raceIndex = 0;
              scope.nextRaceIn = scope.$store.state.screenConfig.raceScrollInterval;
            }
          }

          if(scope.mainRaceCounter >= scope.$store.state.screenConfig.raceScrollInterval) {
            scope.scrollRace();
            scope.mainRaceCounter = 0;
          }

        }, 1000);

      }
    }
  },
  created: function() {
    // moved these to watch to ensure timeout value is loaded.
    // this.startScrollingRaces();
    // this.startScrollingVenues();
  },
  methods: {
    flagImage: function(countryName) {
      if (countryName) {
        return `${this.$store.state.screensUrl}/static/img/${countryName.toLowerCase().replace(' ', '-')}.png`;
      }
    },
    venueDisplayName: function(displayname) {
      if (displayname) {
        return displayname.replace('$VE ', '').trim().toUpperCase();
      }
    },
    scrollRace: function() {
      let scope = this;
      if (scope.hasNextRace) {
        if (scope.quadVenue) {
          if (scope.raceIndex === scope.quadVenue.races.length - 1) {
            scope.raceIndex = 0;
          } else {
            scope.raceIndex++;
          }
          scope.raceFlash = 'flash';
          setTimeout(function() {
            scope.raceFlash = '';
          }, 1000);
        }

        scope.nextRaceIn = scope.$store.state.screenConfig.raceScrollInterval;
      }
    },
    scrollVenue: function() {
      let scope = this;
      if (scope.hasNextVenue) {
        if (scope.venueIndex === scope.quadVenues.length - 1) {
          scope.venueIndex = 0;
        } else {
          scope.venueIndex++;
        }

        scope.venueFlash = 'flash';
        setTimeout(function() {
          scope.venueFlash = '';
        }, 1000);

        scope.nextVenueIn = scope.$store.state.screenConfig.venueScrollInterval;
      }
    }
  }
};
</script>

<style scoped>
.venue-title-bar {
  display: flex;
  flex-direction: row;
  height: 64px;
  font-size: 40px;
  font-weight: bold;
}

.country-flag {}

.venue-title {

  line-height: 64px;
  padding-left: 10px;
}

.the-time {
  flex-grow: 1;
  align-content: flex-end;
  line-height: 64px;
  padding-right: 10px;
  width: 160px;
  text-align: right;
}

.race-title-bar {
  background-color: #fb2e01;
  color: white;
  font-size: 24px;
  height: 64px;
  font-weight: bold;
}

.race-venue-flag {
  float: left;
  height: 64px;
}

.race-venue-name {
  float: left;
  margin-left: 10px;
  max-width: 480px;
  overflow: hidden;
  white-space: nowrap;
}

.race-name {
  line-height: 25px;
}

.race-container-container {
  width: 100%;
}

.noedge {
  border-right: 0;
}

.race-titles {
  float: right;
  color: #fff;
  text-align: center;
}

.race-places-paid {
  float: right;
  color: #fff;
  text-align: right;
  font-size: 12px;
  line-height: 64px;
  margin-left: 0;
}

.price-title {
  float: right;
  font-size: 10px;
  font-size: 14px;
  line-height: 64px;
  width: 90px;
}

.prev-title {
  float: right;
  font-size: 14px;
  line-height: 64px;
  width: 70px;
}

.place-title {
  float: right;
  font-size: 14px;
  line-height: 64px;
  width: 70px;
}

.no-data {
  text-align: center;
  padding-top: 200px;
  font-size: 22px;
  font-weight: bold;
}

.showing-next {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// MultiScreenSection.vue?37331087